import { useTranslation } from "react-i18next";
import { Grid, Text } from "@mantine/core";
import { CampaignInquiryQueryDataType } from "src/hooks/campaignInquiries";
import { checkDeliveryType } from "src/utils/helpers";

import { FormItem } from "../../../FormItem";

export interface CampaignInquiryDeliveryProps {
    campaignInquiry: CampaignInquiryQueryDataType;
}

export const CampaignInquiryDelivery = ({ campaignInquiry }: CampaignInquiryDeliveryProps) => {
    const { t } = useTranslation(["common"]);

    return (
        <Grid>
            <Grid.Col xs={12} sm={12} md={5}>
                <FormItem label={t("campaign_delivery_type")}>
                    {campaignInquiry?.delivery?.type && checkDeliveryType(campaignInquiry?.delivery?.type) ? (
                        t(`campaign_delivery_type_${campaignInquiry.delivery.type}`)
                    ) : (
                        <Text color="dimmed">-</Text>
                    )}
                </FormItem>
            </Grid.Col>
            <Grid.Col xs={12} sm={12} md={7}>
                <FormItem label={t("campaign_delivery_note")}>
                    {campaignInquiry?.delivery?.notes ? (
                        <Text>{campaignInquiry.delivery.notes}</Text>
                    ) : (
                        <Text color="dimmed">-</Text>
                    )}
                </FormItem>
            </Grid.Col>
        </Grid>
    );
};
